import { getPartnerTypes } from './partnerTypes';

export const initApp = () => async dispatch => {
  dispatch(getPartnerTypes());
};
